/**
 * Main theme definition. Gets merged with MUI default theme.
 * The folder containing this cannot be 'theme' as it messes
 * with the docz/gatsby configuration
 *
 * See default theme here: https://material-ui.com/customization/default-theme/
 */
import { createMuiTheme, responsiveFontSizes } from '@material-ui/core/styles';
import mixins from './mixins';
import overrides from './overrides';
import palette from './palette';
import props from './props';
import shadows from './shadows';
import typography from './typography';
let theme = createMuiTheme({
    mixins,
    overrides,
    palette,
    props,
    shadows,
    typography,
});
// responsive typography
theme = responsiveFontSizes(theme);
theme = {
    ...theme,
    content: {
        padding: theme.spacing(3),
    },
};
export { MuiInputPadding } from './overrides';
export default theme;
//# sourceMappingURL=index.js.map